import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M19 20 10 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m5 20 9-16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 20h18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m12 15-3 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m12 15 3 5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Tent";
const Tent = memo(themed(Icon));
export {
  Tent
};
//# sourceMappingURL=tent.js.map
